import Vue from "vue";
import ConfirmDialog from "../components/cards/VueConfirmDialog.vue";

const confirm = {
  install(VueInstance) {
    if (VueInstance.prototype.$confirm) {
      return;
    }

    VueInstance.prototype.$confirm = function (options = {}) {
      return new Promise((resolve) => {
        const DialogWrapper = Vue.extend({
          data() {
            return {
              isVisible: true,
            };
          },
          render(h) {
            return h(ConfirmDialog, {
              props: {
                show: this.isVisible,
                title: options.title || "Confirmer l'action",
                message:
                  options.message ||
                  "Êtes-vous sûr de vouloir continuer cette action ?",
                button: {
                  yes: options.confirmButtonText || "Oui",
                  no: options.cancelButtonText || "Non",
                },
              },
              on: {
                confirm: () => {
                  this.handleResolve(true);
                },
                cancel: () => {
                  this.handleResolve(false);
                },
              },
            });
          },
          methods: {
            handleResolve(value) {
              this.isVisible = false;
              this.$nextTick(() => {
                if (this.$el && this.$el.parentNode) {
                  this.$el.parentNode.removeChild(this.$el);
                }
                this.$destroy();
                resolve(value);
              });
            },
          },
        });

        const wrapper = new DialogWrapper().$mount();
        document.body.appendChild(wrapper.$el);
      });
    };
  },
};

export default confirm;

